export const FIELDS = {
  make_id: {
    name: "",
    value: "",
    error: "",
  },
  city_id: {
    name: "",
    value: "",
    error: "",
  },
  dealership_name: {
    name: "",
    value: "",
    error: "",
  },
};
